import {
  createSpeed,
  speedToFps,
  speedToMs,
  speedToMph,
  speedToKmh,
  speedToKnots,
} from 'measure-fns';
import { ConversionOptions } from 'measure-fns/dist/interfaces';

export const convertSpeed = (
  rawSpeed: number,
  unit: string | undefined,
  options: ConversionOptions = { round: 2 },
): string => {
  const resolvedUnit = unit ?? 'mph';
  const speed = createSpeed(rawSpeed);
  switch (resolvedUnit) {
    case 'm-s':
      return `${speedToMs(speed, options)} m/s`;
    case 'f-s':
      return `${speedToFps(speed, options)} f/s`;
    case 'mph':
      return `${speedToMph(speed, options)} mph`;
    case 'km-h':
      return `${speedToKmh(speed, options)} km/h`;
    case 'kn':
      return `${speedToKnots(speed, options)} kt`;
    default:
      throw new Error(`Unsupported unit: ${resolvedUnit}`);
  }
};
